function getDefaultFields (yup) {

	return {
		firstName: yup
			.string()
			.alphanumeric()
			.restrictedCharacters()
			.max(30, ({ max }) => `${max} characters max.`)
			.required(),

		lastName: yup
			.string()
			.alphanumeric()
			.restrictedCharacters()
			.max(30, ({ max }) => `${max} characters max.`)
			.required(),

		email: yup
			.string()
			.email()
			.emailRequireDomainSuffix()
			.max(50, ({ max }) => `Please enter no more than ${max} characters.`)
			.required(),

		emailConfirm: yup
			.string()
			.required()
			.restrictedCharacters()
			.oneOf([ yup.ref('email'), null ], 'Email must match'),

		phoneNumber: yup.string().phoneNumber(),

		zipCode: yup
			.string()
			.restrictedCharacters()
			.max(10, ({ max }) => `Please enter no more than ${max} characters.`),

		password: yup
			.string()
			.min(6)
			.max(128)
			.containsAtLeastOneLetter()
			.containsAtLeastOneDigit()
			.restrictedCharacters()
			.required(),

		passwordConfirm: yup
			.string()
			.required()
			.oneOf([ yup.ref('password'), null ], 'Passwords must match')
	};

}

export { getDefaultFields };
